// redux/data/dataActions.js
import store from "../store";

const fetchDataRequest = () => ({
  type: "CHECK_DATA_REQUEST",
});

const fetchDataSuccess = (payload) => ({
  type: "CHECK_DATA_SUCCESS",
  payload: payload,
});

const fetchDataFailed = (payload) => ({
  type: "CHECK_DATA_FAILED",
  payload: payload,
});

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      const contract = store.getState().blockchain.smartContract;
      if (!contract) {
        throw new Error("Smart contract not loaded");
      }

      const totalSupplyBN = await contract.totalSupply();
      const totalSupply = totalSupplyBN.toString(); // Convertimos BigInt a string

      dispatch(fetchDataSuccess({ totalSupply }));
    } catch (err) {
      console.error(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
